var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.948 22.5c.58 0 1.052.448 1.052 1 0 .553-.471 1-1.052 1H2.552c-.58 0-1.052-.447-1.052-1 0-.552.471-1 1.052-1h25.396zM15.032 5.538L16.5 7.011h.003l5.441 5.455c.272.273.714.273.986 0l.074-.087c.196-.272.171-.655-.074-.901L18.476 7.01h8.268l2.82 5.587h-2.17v8.596H17.36v-4.086c-.05-1.213-1.071-2.183-2.328-2.183s-2.278.97-2.323 2.183h-.005v4.086H2.671v-8.596H.5l2.82-5.587h8.269l-4.456 4.467c-.272.273-.272.715 0 .988l.086.074c.273.196.655.172.9-.074l5.441-5.455h.003l1.469-1.473zm7.22 9.607c-.891 0-1.616.69-1.649 1.55h-.002v2.511c0 .258.208.468.465.468h2.372c.258 0 .467-.21.467-.468v-2.512c-.036-.86-.76-1.549-1.652-1.549zm-14.44 0c-.892 0-1.617.69-1.65 1.55H6.16v2.511c0 .258.208.468.466.468h2.372c.257 0 .466-.21.466-.468v-2.512c-.035-.86-.76-1.549-1.651-1.549zm7.22-5.71c-.947 0-1.715.77-1.715 1.72s.768 1.719 1.715 1.719c.947 0 1.715-.77 1.715-1.72 0-.948-.768-1.718-1.715-1.718z",
    transform: "translate(-267 -1838) translate(267 1838)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledSchool);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-school.17035c733c90fa493cabe4de94c83e3c.svg";
export { ForwardRef as ReactComponent };